import React, { HTMLAttributes } from 'react'

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
    className?: string
    size?: 'xl' | 'md' | 'sm'
    children: React.ReactNode
}

const Container: React.FC<ContainerProps> = ({ children, className = '', size = 'xl', ...args }) => {
    const getSize = () => {
        switch (size) {
            case 'md':
                return '64rem'
            case 'sm':
                return '42.667rem'
            default:
                return '200rem'
        }
    }
    return (
        <div className={`max-w-[${getSize()}] m-auto ${className}`} {...args}>
            <span className="max-w-[200rem] max-w-[64rem] max-w-[42.667rem] hidden"></span>
            {children}
        </div>
    )
}

export default Container
